import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';
import { ArquivoUrl } from "../interface/arquivo-url";

@Injectable()
export class ArquivoStorageService extends EntityService<any> {

  constructor(private _httpClient: HttpClient) {
    super(_httpClient);
    this.resource = '/api/arquivo-storage';
  }

  public getUrlAssinada(fullPath: string, fileName: string): Observable<ArquivoUrl> {
    const params = `fullPath=${fullPath}&fileName=${fileName}`;

    return this.httpClient.get({
      resource: `${this.resource}?${params}`,
      disableSpinner: false
    });
  }

  public getDisplay(fullPath: string, fileName: string): Observable<any> {
    const params = `fullPath=${fullPath}&fileName=${fileName}`;

    return this.httpClient.get({
      resource: `${this.resource}/display?${params}`,
      disableSpinner: true
    });

  }

}
